import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface HookSlideProps {
  onStart: () => void;
}
export function HookSlide({
  onStart
}: HookSlideProps) {
  return <div className="flex-1 flex items-center justify-center px-5 py-10" data-id="element-65">
      <motion.div className="w-full max-w-sm text-center" initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-66">
        <div className="inline-flex items-center gap-1.5 bg-era-red-light text-era-red text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-6" data-id="element-67">
          Clinical Self-Assessment
        </div>

        <h1 className="text-2xl font-bold text-clinical-text leading-tight mb-4" data-id="element-68">
          Are clinicians aligned on IgAN management?
        </h1>

        <p className="text-clinical-secondary text-sm leading-relaxed mb-8" data-id="element-69">
          Approaches to IgA nephropathy vary more than expected. Compare your
          decisions with peers across roles.
        </p>

        <motion.button whileTap={{
        scale: 0.96
      }} onClick={onStart} className="w-full inline-flex items-center justify-center gap-2 bg-era-red active:bg-era-red-dark text-white font-bold px-6 py-3.5 rounded-2xl transition-colors duration-150 text-sm" data-id="element-70">
          Start survey
          <ArrowRightIcon className="w-4 h-4" data-id="element-71" />
        </motion.button>

        <p className="text-clinical-muted text-xs mt-5" data-id="element-72">
          4 questions · 2 minutes · anonymous
        </p>
      </motion.div>
    </div>;
}